import React, { useEffect } from 'react';
import ApexCharts from 'apexcharts';
import { chartOptions } from '../consts';

export function SalesGraph({ data, merchantId, merchants }) {
	const id = 'sales-graph';

	useEffect(() => {
		const element = document.getElementById(id);

		if (!element) {
			return;
		}
		const options = getChartOption(data, merchantId, merchants);
		const chart = new ApexCharts(element, options);
		chart.render();

		return function cleanUp() {
			chart.destroy();
		};
	}, [data, merchantId, merchants]);

	return <div id={id}></div>;
}

function getChartOption(data, merchantId, merchants) {
	const dates = data?.result || [];
	const series =
		merchantId === 'all'
			? merchants.slice(1).map((m) => ({
					name: m.label,
					data: dates.map((d) => d[m.merchantId] || 0),
			  }))
			: [
					{
						name: merchants.find((m) => m.merchantId === merchantId)?.label || 'Sales',
						data: dates.map((d) => d.total || 0),
					},
			  ];
	const options = {
		series,
		colors: ['#FE6F5E', '#17C5BD', '#D55DB1', '#835FC2', '#FFC75F'],
		...chartOptions(dates),
	};
	return options;
}
